import React, { useState, useEffect, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import ChartInputNumeric from "./ChartInputNumeric"
import { changeChartDate, changeAshiCount, pickTarget } from "redux/ducks/Chart"
import {
  TOOLS,
  PLOTTYPE,
  MAX_SCROLL_SPAN,
  LIMIT_RENDER_COUNT,
  CHART_ASHI_MIN,
} from "../logic/chartConfig"
import { convertDate, getFutureSpan, resetUiSpan } from "../logic/chartSpan"
import { find, pick, isEmpty, get } from "lodash"
import classNames from "classnames"

interface props {
  canvasId: string
}

export const CHART_ASHI_LIMIT_COUNT = [6520, 1304, 218, 111, 1305, 261, 60]

const ChartLegCount = React.memo((props: props) => {
  const { canvasId } = props
  const dispatch = useDispatch()

  const plotTypeSelector = (state: any) => state.chart[canvasId].plotType
  const providersSelector = (state: any) => state.chart[canvasId].providers
  const renderCountSelector = (state: any) => state.chart[canvasId].renderCount
  const symbolSelector = (state: any) => state.chart[canvasId].symbol
  const toolsSelector = (state: any) => state.chart[canvasId].tools
  const ashicountSelector = (state: any) => state.chart[canvasId].ashicount

  const plotType = useSelector(plotTypeSelector)
  const providers = useSelector(providersSelector)
  const renderCount = useSelector(renderCountSelector)
  const symbol = useSelector(symbolSelector)
  const tools = useSelector(toolsSelector)
  const ashicount = useSelector(ashicountSelector)

  const [_provider, _controller, _procs] = providers

  const [maxLen, setMaxLen] = useState(renderCount)
  const [_renderCount, setRenderCount] = useState(renderCount)
  const loupeFlag = !!find(tools, pick(TOOLS[4], pickTarget))
  const PandFFlag = plotType.id === PLOTTYPE[3].id

  const updeteRenderCount = (renderCount: number) => {
    const _maxLen = _controller.Chart.GetMainSeriesLen()
    if (get(_maxLen, "$0") && renderCount > _maxLen.$0) return
    const _maxSpan = MAX_SCROLL_SPAN - getFutureSpan(_controller)
    if (renderCount < _maxSpan)
      renderCount = maxLen < _maxSpan ? _maxLen.$0 : _maxSpan

    const res = _controller.Chart.UpdatePortKikan(renderCount)
    const sspan = res.$0
    const espan = res.$1 ? res.$1.$0 : null
    const _sspan = convertDate(sspan)
    const _espan = convertDate(espan)
    dispatch(
      changeChartDate(canvasId, [
        new Date(_sspan[0], _sspan[1], _sspan[2]),
        new Date(_espan[0], _espan[1], _espan[2]),
      ])
    )
  }

  const _changeAshiCount = (num: number) => {
    if (!_controller || loupeFlag || PandFFlag || isEmpty(symbol)) return
    const _maxLen = _controller.Chart.GetMainSeriesLen()
    setMaxLen((_maxLen.$0 as number) || LIMIT_RENDER_COUNT)
    dispatch(changeAshiCount(canvasId, num))
    if (!loupeFlag) updeteRenderCount(num)
    _controller.Chart.Draw()
  }

  useEffect(() => {
    if (!_controller || loupeFlag || PandFFlag || isEmpty(symbol)) return
    const _maxLen = _controller.Chart.GetMainSeriesLen()
    setMaxLen((_maxLen.$0 as number) || LIMIT_RENDER_COUNT)
  }, [_controller])

  useEffect(() => {
    if (!_controller || PandFFlag || isEmpty(symbol)) return
    // DatePickerから変更されることがあるため、監視。
    if (_renderCount !== ashicount) setRenderCount(ashicount)
  }, [ashicount])

  return (
    <div
      className={classNames("chart-leg-count filter-control-item", {
        disabled: loupeFlag || PandFFlag || isEmpty(symbol),
      })}
    >
      <ChartInputNumeric
        min={
          getFutureSpan(_controller)
            ? MAX_SCROLL_SPAN - getFutureSpan(_controller)
            : MAX_SCROLL_SPAN
        }
        max={maxLen}
        defaultValue={_renderCount}
        step={1}
        decimalDigits={0}
        setValue={(num: number) => {
          setRenderCount(num)
          _changeAshiCount(num)
        }}
        mini={true}
      />
      <span>本</span>
    </div>
  )
})

export default ChartLegCount
